<template>
  <div class="p-4 p-md-0 mb-4">
    <div class="row mt-3 mb-4">
      <div class="col col-sm col-12">
        <em class="fas fa-calendar-plus text-orange mr-1" />
        <span class="color-gray-7 font-16 font-weight-bold">
          Completar Discusión de la Evaluación
        </span>
      </div>
    </div>
    <validation-observer ref="completeDiscussionFormRef" novalidate tag="form">
      <div class="row">
        <div class="col-md-3 col-sm-12 mt-3 mt-md-0">
          <div class="color-gray-6 font-14 mb-1">
            Fecha de Discusión de la Evaluación:
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-date-picker
              v-model="model.date"
              class-container="w-100"
              custom-error-msg="La fecha es requerida."
              :error="errors[0]"
              format="dd/MMM./yyyy"
              :max-date="new Date()"
              :min-date="minDate"
              placeholder="DD/MM/YYYY"
            />
          </validation-provider>
        </div>
        <div class="col-md-4 col-sm-12 mt-3 mt-md-0">
          <div class="color-gray-6 font-14 mb-1">Archivo:</div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-file-input
              ref="documentFileRef"
              v-model="model.file"
              accept=".pdf"
              custom-error-msg="El documento de la discusión es requerido."
              display-style="normal"
              :error="errors[0]"
              label-position="left"
              :on-download="() => {}"
              required
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="mt-3 mb-3 align-items-center d-flex justify-content-end">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 pl-3 pr-4"
        @click="$emit('cancel')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="onSaveHandler"
      />
    </div>
  </div>
</template>

<script>
import objectToFormData from 'object-to-formdata';
import moment from 'moment';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

//component libs
import ActionButton from 'ActionButton';
import CustomDatePicker from 'custom-date-picker';
import CustomFileInput from 'CustomFileInput';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

//services
import { saveEvaluationDiscussion as _saveEvaluationDiscussion } from '@/services/uspqrp/contract.api.js';

export default {
  name: 'CompleteDiscussion',
  mixins: [alertMixin],
  components: {
    ValidationObserver,
    ValidationProvider,
    ActionButton,
    CustomDatePicker,
    CustomFileInput,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    model: {
      date: null,
      file: null,
    },
  }),
  computed: {
    minDate() {
      if (!this.data.additionalInformation.completedEvaluationDate) {
        return null;
      }
      const d = new Date(
        this.data.additionalInformation.completedEvaluationDate
      );
      return d.setDate(d.getDate() - 1);
    },
  },
  methods: {
    async onSaveHandler() {
      const isFormValid = await this.$refs.completeDiscussionFormRef.validate();

      if (!isFormValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro(a) que desea completar la discusión de la evaluación?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      const params = objectToFormData(
        {
          contractId: this.data.contractId,
          date: moment(this.model.evaluationDate)
            .locale('es-PR')
            .format('DD/MMM/YYYY'),
          file: this.model.file,
        },
        { indices: true, nullsAsUndefineds: true }
      );

      const { data: result } = await _saveEvaluationDiscussion(params).catch(
        (err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        }
      );

      if (result) {
        this.ShowToast(
          'Proceso Exitoso',
          'La discusión de la evaluación ha sido asignada exitosamente.',
          'success'
        );
        this.$emit('saved', result);
      }
    },
  },
};
</script>
